import React from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { Layout } from 'antd';
import { Link } from 'react-router-dom';

import { sample } from 'src/utils/helper';

const { Footer } = Layout;
const mojiList = ['🤤', '🙃', '😳', '😵', '😇', '🤓', '🤖', '✍', '🐉', '🚀'];

const useStyles = createUseStyles({
	footer: {
		display: 'flex',
		justifyContent: 'center',
		marginTop: 'auto',
		background: 'transparent',
	},
	card: {
		marginTop: '60px',
	},
});

export const CustomFooter = (props) => {
	const { t } = useTranslation();
	const classes = useStyles();
	return (
		<Footer className={classes.footer}>
			{' '}
			{`${sample(mojiList)} ${t('mainSettings.impressumSettings.developedBy', '*developed by')} `}
			{<span> &nbsp;</span>}
			{
				<a target='_blank' href='http://www.ipk.fraunhofer.de'>
					Fraunhofer IPK&nbsp;
				</a>
			}
			{` - Prozessassistent ${new Date().getFullYear()} - `}
			{<span> &nbsp;</span>}
			<Link to='/impressum'>Impressum</Link>
			{<span> &nbsp;|&nbsp;</span>}
			<Link to='/privacy'> {t('mainSettings.privacySettings.name', '*Privacy')} </Link>
		</Footer>
	);
};
